import React from "react";

const TableExampleSelectableInvertedRow = (prop) => (
    <div>
        {!prop?.cards ? (
            <></>
        ) : (
            <>
           
           
                {prop.cards.map(function (card, i) {
              
                        var c = card.split("");
                     
                        return <span key={i}  data-rank={c[0].toUpperCase()} className={"card "+ c[1]}></span>
             
               
                   
                })}
            </>
        )}
    </div>
);

export default TableExampleSelectableInvertedRow;
